function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.15",
  d: "M5.813 7.313H3.75a1.5 1.5 0 01-1.5-1.5V3.75a1.5 1.5 0 011.5-1.5h2.063a1.5 1.5 0 011.5 1.5v2.063a1.5 1.5 0 01-1.5 1.5zm8.437 0h-2.063a1.5 1.5 0 01-1.5-1.5V3.75a1.5 1.5 0 011.5-1.5h2.063a1.5 1.5 0 011.5 1.5v2.063a1.5 1.5 0 01-1.5 1.5zM5.813 15.75H3.75a1.5 1.5 0 01-1.5-1.5v-2.063a1.5 1.5 0 011.5-1.5h2.063a1.5 1.5 0 011.5 1.5v2.063a1.5 1.5 0 01-1.5 1.5zm8.437 0h-2.063a1.5 1.5 0 01-1.5-1.5v-2.063a1.5 1.5 0 011.5-1.5h2.063a1.5 1.5 0 011.5 1.5v2.063a1.5 1.5 0 01-1.5 1.5z",
  clipRule: "evenodd"
}));